import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=031deb74&"
import script from "./empty.vue?vue&type=script&lang=js&"
export * from "./empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "empty.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/base/empty/empty.vue
// module id = 113
// module chunks = 0